module.exports = __webpack_public_path__ + "media/images/icons/favorite-b163643dd570b7310ac132ca3d0656e7.svg";